import { ButtonsModule } from '@anecdotes/design-system/buttons';
import { DataFilterModule, DataSortModule, FilterPanelService } from '@anecdotes/design-system/data-manipulation';
import { DirectivesModule } from '@anecdotes/design-system/directives';
import { DropdownMenuModule } from '@anecdotes/design-system/dropdown-menu';
import { GridModule } from '@anecdotes/design-system/grid';
import { ModalsModule } from '@anecdotes/design-system/modals';
import { MultiselectModule } from '@anecdotes/design-system/multiselect';
import { PipesModule } from '@anecdotes/design-system/pipes';
import { RenderingModule } from '@anecdotes/design-system/rendering';
import { TipsModule } from '@anecdotes/design-system/tips';
import { UtilsModule } from '@anecdotes/design-system/utils';
import { SharedPolicyModule } from '@anecdotes/shared-policy';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicFormModule } from '@anecdotes/dynamic-form';
import { CoreModule } from 'core';
import { AccountFeaturesModule } from '@anecdotes/account-features';
import { HeadersModule } from '@anecdotes/ui/headers';
import { ControlsSharedModule } from '@anecdotes/shared-controls';
import { PluginsUiModule } from '@anecdotes/plugins-ui';
import {
  AccessComponent,
  AccessGrantedModalComponent,
  AccessManagerItemComponent,
  AccessManagerRendererComponent,
  AccessRequestSidePanelComponent,
  CompaniesRendererComponent,
  CompanyItemComponent,
  CreatedSourceLabelComponent,
  GrantAccessModalComponent,
  RequestsItemComponent,
  RequestsRendererComponent,
  ProfileDropdownComponent,
  CompanyNdaStatusComponent,
  CompanySidePanelComponent,
} from './components';
import { SharedTrustCenterModule } from '@anecdotes/shared-trust-center';
import { FeatureFlagsModule } from '@anecdotes/feature-flags';

@NgModule({
  declarations: [
    AccessComponent,
    RequestsItemComponent,
    RequestsRendererComponent,
    AccessManagerRendererComponent,
    AccessManagerItemComponent,
    GrantAccessModalComponent,
    AccessGrantedModalComponent,
    ProfileDropdownComponent,
    AccessRequestSidePanelComponent,
    CompaniesRendererComponent,
    CompanyItemComponent,
    CreatedSourceLabelComponent,
    CompanyNdaStatusComponent,
    CompanySidePanelComponent,
  ],
  imports: [
    CommonModule,
    CoreModule,
    TranslateModule.forChild(),
    HeadersModule,
    DataFilterModule,
    UtilsModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatButtonModule,
    ReactiveFormsModule,
    DynamicFormModule,
    ControlsSharedModule,
    ModalsModule,
    NgbTooltipModule,
    PluginsUiModule,
    AccountFeaturesModule,
    VirtualScrollerModule,
    ButtonsModule,
    MultiselectModule,
    TipsModule,
    SharedPolicyModule,
    DataSortModule,
    RenderingModule,
    DirectivesModule,
    PipesModule,
    DropdownMenuModule,
    GridModule,
    SharedTrustCenterModule,
    FeatureFlagsModule,
  ],
  providers: [FilterPanelService],
  exports: [
    AccessComponent,
    RequestsItemComponent,
    RequestsRendererComponent,
    AccessManagerRendererComponent,
    AccessManagerItemComponent,
    GrantAccessModalComponent,
    AccessGrantedModalComponent,
    ProfileDropdownComponent,
    AccessRequestSidePanelComponent,
    CompaniesRendererComponent,
    CompanyItemComponent,
    CreatedSourceLabelComponent,
    CompanyNdaStatusComponent,
    CompanySidePanelComponent,
  ],
})
export class AccessModule {}
